import React from "react";
import { Control, Controller } from "react-hook-form";

import {
  RateField,
  processTypes,
  rateField,
  rateLabel,
} from "../../static/processRate";
import { IFormInput } from "../../types/item";
import RateInput from "../ui/RateInput";
import { fieldLabelClass } from "../ui/styles";

// The item's own rates, or one sub item row's.
type RatePath = RateField | `sub_items.${number}.${RateField}`;

type Props = {
  control: Control<IFormInput>;
  // "" for the item itself, or "sub_items.{index}." for a sub item row.
  prefix: "" | `sub_items.${number}.`;
  idPrefix: string;
};

// One cell per process rate. They are optional, and separate from the rates each party gets on its own page.
// An item or sub item with sizes has a row of these per size instead (ItemSizeRates).
const ItemRateFields = ({ control, prefix, idPrefix }: Props) => (
  <>
    {processTypes.map((type) => {
      const field = rateField(type.value);
      const inputId = `${idPrefix}-${field}`;

      return (
        <div key={type.value} className="space-y-2">
          <label htmlFor={inputId} className={fieldLabelClass}>
            {rateLabel(type)} (વૈકલ્પિક)
          </label>
          <Controller
            control={control}
            name={`${prefix}${field}` as RatePath}
            render={({ field: rate }) => (
              <RateInput
                ref={rate.ref}
                id={inputId}
                name={rate.name}
                value={rate.value}
                placeholder="દા.ત. 120"
                onChange={rate.onChange}
                onBlur={rate.onBlur}
              />
            )}
          />
        </div>
      );
    })}
  </>
);

export default ItemRateFields;
